import BasicDomain from "./BasicDomain";
import * as yup from 'yup';

export default class PersonName extends BasicDomain {
    static DEFAULTS = {
      name: null,
      person: null,
    }

    static VALIDATION_SCHEMA = yup.object({
      name: yup.string().required('Name is required'),
    }).required();

    constructor(props) {
        super('PersonName', props, PersonName.DEFAULTS);
    }
}

if (global.Parse.Object.registerSubclass) {
    global.Parse.Object.registerSubclass('PersonName', PersonName);
}
